import { Routes } from '@angular/router';
import { FIELDS_BASE_PATHS } from '../../base-paths';

export const FIELD_VALUES_ADMIN_ROUTING: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./components/field-values-table/field-values-table.component').then((m) => m.FieldValuesTableComponent),
  },
  {
    path: '**',
    redirectTo: `/${FIELDS_BASE_PATHS.FIELD_VALUES}`,
    pathMatch: 'full',
  },
];
